/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ComplianceTimelineEventName = {
    Compliant: 'COMPLIANT',
    NotCompliant: 'NOT_COMPLIANT',
    InternallyCompliant: 'INTERNALLY_COMPLIANT',
    InternallyNotCompliant: 'INTERNALLY_NOT_COMPLIANT',
    ExternallyCompliant: 'EXTERNALLY_COMPLIANT',
    ExternallyNotCompliant: 'EXTERNALLY_NOT_COMPLIANT',
    UserCreation: 'USER_CREATION',
    UserUpdate: 'USER_UPDATE',
    UserRefused: 'USER_REFUSED',
    BankAccountCreation: 'BANK_ACCOUNT_CREATION',
    BankAccountDeletion: 'BANK_ACCOUNT_DELETION',
    UmbrellaCompanyApplicationRequested: 'UMBRELLA_COMPANY_APPLICATION_REQUESTED',
    UmbrellaCompanyApplicationCanceled: 'UMBRELLA_COMPANY_APPLICATION_CANCELED',
    UmbrellaCompanyApplicationRefused: 'UMBRELLA_COMPANY_APPLICATION_REFUSED',
    UmbrellaCompanyInvited: 'UMBRELLA_COMPANY_INVITED',
    UmbrellaCompanyJoined: 'UMBRELLA_COMPANY_JOINED',
    UmbrellaCompanyLeft: 'UMBRELLA_COMPANY_LEFT',
    UmbrellaRemovedFreelancer: 'UMBRELLA_REMOVED_FREELANCER',
    CompanyTypeUpdated: 'COMPANY_TYPE_UPDATED',
    KycDocumentUploaded: 'KYC_DOCUMENT_UPLOADED',
    KycDocumentStored: 'KYC_DOCUMENT_STORED',
    KycDocumentAccepted: 'KYC_DOCUMENT_ACCEPTED',
    KycDocumentAcceptedAutoFetched: 'KYC_DOCUMENT_ACCEPTED_AUTO_FETCHED',
    KycDocumentRefused: 'KYC_DOCUMENT_REFUSED',
    KycDocumentExpired: 'KYC_DOCUMENT_EXPIRED',
    KycDocumentInternallyOutdated: 'KYC_DOCUMENT_INTERNALLY_OUTDATED',
    FraudReport: 'FRAUD_REPORT',
    UboFilled: 'UBO_FILLED',
    UboSubmitted: 'UBO_SUBMITTED',
    UboValidated: 'UBO_VALIDATED',
    UboIncomplete: 'UBO_INCOMPLETE',
    UboRefused: 'UBO_REFUSED',
    DocumentUploadRequested: 'DOCUMENT_UPLOAD_REQUESTED',
    IdentityVerificationStatusUpdated: 'IDENTITY_VERIFICATION_STATUS_UPDATED',
    FreelancerComplianceBlocked: 'FREELANCER_COMPLIANCE_BLOCKED',
    FreelancerComplianceUnblocked: 'FREELANCER_COMPLIANCE_UNBLOCKED'
} as const;
export type ComplianceTimelineEventName = typeof ComplianceTimelineEventName[keyof typeof ComplianceTimelineEventName];


export function instanceOfComplianceTimelineEventName(value: any): boolean {
    for (const key in ComplianceTimelineEventName) {
        if (Object.prototype.hasOwnProperty.call(ComplianceTimelineEventName, key)) {
            // @ts-ignore
            if (ComplianceTimelineEventName[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ComplianceTimelineEventNameFromJSON(json: any): ComplianceTimelineEventName {
    return ComplianceTimelineEventNameFromJSONTyped(json, false);
}

export function ComplianceTimelineEventNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplianceTimelineEventName {
    return json as ComplianceTimelineEventName;
}

export function ComplianceTimelineEventNameToJSON(value?: ComplianceTimelineEventName | null): any {
    return value as any;
}

